import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import { LoginWrapper } from "./LoginWrapper";
import { formValidator } from "utils/FormValidator/FormValidator";
import blackMadam from "assets/images/black-madam.jpg";
import { ReactComponent as Logo } from "assets/images/icons/bluintouch-logo-dark.svg";
import { Link } from "react-router-dom";
import API from "api";
import { useMutation } from "react-query";
import { verifyResetPassword } from "api/auth";
import Alert from "utils/Alert/Alert";
import CustomSpinner from "utils/Spinner/Spinner";
import {
  CONTACT_US_LINK,
  ERROR,
  PRIVACY_POLICY_LINK,
  SUCCESS,
} from "utils/helpers/constants";
import { toastHandler } from "utils/helpers/toast";
import { titleCase } from "utils/helpers";
import CustomPassword from "utils/inputBox/CustomInputBox/CustomPassword";

const ResetPassword = () => {
  const history = useHistory();
  const { id } = useParams();
  const [errorMsg, setErrorMsg] = useState();
  const [formValues, setFormValues] = useState({
    password: "",
    confirmPassword: "",
  });
  const [formErrors, setFormErrors] = useState({});

  const handleChange = ({ target: { name, value } }) => {
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
    setFormErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  function handleSubmit(e) {
    e.preventDefault();
    const { formErrors, isValid } = formValidator(formValues);
    isValid ? mutate() : setFormErrors(formErrors);
  }

  const { mutate, isLoading } = useMutation(
    async () => {
      setErrorMsg();
      const payload = {
        password: formValues.password,
        token: id,
      };
      const response = await API.put(verifyResetPassword, payload);
      return response;
    },
    {
      onSuccess: ({ data, status }) => {
        if (status === 200 && data?.success) {
          toastHandler(titleCase("Password Reset Successful"), SUCCESS);
          setTimeout(() => {
            history.push("/login");
          }, 2000);
        }
      },
      onError: (error) => {
        toastHandler(titleCase(error?.data?.data?.error), ERROR);
      },
    }
  );

  return (
    <LoginWrapper className=" d-flex">
      <div className="left-div">
        <div className="auth-nav flex__between">
          <Logo className="pointer" />
          <div className="auth-nav-links d-flex">
            <a
              href={PRIVACY_POLICY_LINK}
              to={PRIVACY_POLICY_LINK}
              target="_blank"
              rel="noreferrer"
              className="mx-4"
            >
              Privacy Policy
            </a>
            <a
              to={CONTACT_US_LINK}
              target="_blank"
              rel="noreferrer"
              href={CONTACT_US_LINK}
            >
              Contact Us
            </a>
          </div>
        </div>
        <div className="login-form">
          <div className="px-5 py-4">
            {errorMsg && (
              <Alert message={errorMsg} onClose={() => setErrorMsg()} />
            )}
          </div>
          <h2 className="m-0 p-0">Reset Password</h2>
          <p className="m-0 text--md">Enter your new password to continue</p>
          <form onSubmit={handleSubmit}>
            <CustomPassword
              placeholder="Enter Password"
              error={formErrors?.password}
              name="password"
              onChange={handleChange}
              value={formValues?.password}
            />
            <CustomPassword
              placeholder="Enter Password to Confirm"
              error={formErrors?.confirmPassword}
              name="confirmPassword"
              onChange={handleChange}
              value={formValues?.confirmPassword}
            />
            <button className="btn btn--primary btn--lg" type="submit">
              {isLoading ? <CustomSpinner /> : "Submit"}
            </button>
            <p className="mt-5 heading-3">
              Already have an account?{" "}
              <Link className="text--secondary" to="/login">
                Login
              </Link>
            </p>
          </form>
        </div>
        <div>
          <p className="mt-5">© Blusalt Financial Service Ltd. </p>
        </div>
      </div>
      <div className="right-img-div">
        <img src={blackMadam} alt="black madam" />
      </div>
    </LoginWrapper>
  );
};

export default ResetPassword;
